/**
 * AppPropertiesService — reads the tenant's public app-properties.json from S3.
 *
 * This is the same per-tenant config object ilearn consumes at boot (and that
 * the Tenant Preferences page edits via nodefork /v1/tenant-config). iteach
 * reads it directly for boot-time needs (currently the `theme` block) because
 * it is public-read and needs no API round-trip or auth.
 *
 * IMPORTANT: plain fetch, NOT myAxios — S3 rejects requests carrying a Bearer
 * Authorization header, and this must work pre-login anyway.
 */
import Config from "../_config/config";

// Same bucket/URL pattern as ilearn's ApiService.fetchGoogleAnalytics()
const APP_PROPERTIES_URL = `https://tuningfork-live.s3.ap-southeast-1.amazonaws.com/${Config.site}/files/app-properties.json`;

export type AppProperties = Record<string, any>;

export async function fetchAppProperties(): Promise<AppProperties | null> {
  try {
    const res = await fetch(APP_PROPERTIES_URL, { cache: "no-store" });
    if (!res.ok) return null;
    const data = await res.json();
    return typeof data === "string" ? JSON.parse(data) : data;
  } catch {
    // Missing object / network failure — caller falls back to bundled defaults.
    return null;
  }
}
